module.exports = __webpack_public_path__ + "static/media/repair-grandson1.b0c024a4.jpg";